import { useTranslations } from 'next-intl';
import { type FC, useCallback } from 'react';

import { Button } from '@/components/common/button/Button';
import { ButtonLink } from '@/components/common/button/ButtonLink';
import { Flex } from '@/components/common/Flex';
import { Text } from '@/components/common/Text';
import { richComponents } from '@/constants/rich/richComponents';
import { urls } from '@/constants/urls';
import { useRouter } from '@/i18n/routing';

import styles from './SuccessStep.module.scss';

export type SuccessStepProps = {
  email: string;
};

export const SuccessStep: FC<SuccessStepProps> = (props) => {
  const t = useTranslations('pages.account.passwordRecovery.form.steps.success');

  const { email } = props;

  const router = useRouter();

  const goBack = useCallback(() => {
    router.back();
  }, [router]);

  return (
    <Flex direction="column" gap={9}>
      <Flex className={styles.titleBlock} direction="column" gap={4}>
        <Text type="medium64" whiteSpace="preWrap">
          {t('title')}
        </Text>

        <Text type="regular18" color="white-50p">
          {t.rich('subtitle', {
            ...richComponents,
            email,
          })}
        </Text>
      </Flex>

      <Flex className={styles.formContainer} direction="column">
        <div className={styles.descriptionBlock}>
          <Text type="medium18">{t('description')}</Text>
        </div>

        <Flex direction="column" gap={4}>
          <ButtonLink href={urls.Login}>{t('buttons.login')}</ButtonLink>

          <Button variant="secondary" onClick={goBack}>
            {t('buttons.back')}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};
